import { useMemo, useRef, useState } from 'react';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { ANIMATION } from '@/constants/animation';

type OpeningAnimation = typeof ANIMATION.FROM_RIGHT | typeof ANIMATION.FROM_LEFT| typeof ANIMATION.FROM_DOWN;
type ClosingAnimation = typeof ANIMATION.TO_RIGHT | typeof ANIMATION.TO_LEFT | typeof ANIMATION.TO_DOWN;
type Animation = OpeningAnimation | ClosingAnimation;

type AnimationProps = {
  opening?: OpeningAnimation;
  closing?: ClosingAnimation;
  openingMobile?: OpeningAnimation;
  closingMobile?: ClosingAnimation;
};

export const useAnimation = ({
  opening = ANIMATION.FROM_RIGHT,
  closing = ANIMATION.TO_RIGHT,
  openingMobile = ANIMATION.FROM_DOWN,
  closingMobile = ANIMATION.TO_DOWN
}: AnimationProps = {}) => {
  const isMobile = useScreenSizeContext().isMobile;

  const [animation, setAnimation] = useState<Animation>(!isMobile ? opening : openingMobile);
  const animationRef = useRef<Animation>(animation);
  const animationState = useMemo(() => animation, [animation]);

  const handleCloseModal = () => {
    animationRef.current = !isMobile ? closing : closingMobile;
    setAnimation(() => animationRef.current);
  };

  const resetSecondModal = () => {
    animationRef.current = !isMobile ? opening : openingMobile;
    setAnimation(() => animationRef.current);
  };

  return {
    animationState,
    handleCloseModal,
    resetSecondModal
  };
};
